import React, { useEffect, useState } from "react"
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet"
import L from "leaflet"
import "leaflet/dist/leaflet.css"
import geocodeAddress from "./geocodeAddress"
import { useUser } from "../contexts/UserContext"
import { getStatusAggregate, mapStatus, getStatusColor } from "../utils/mappers"
import { useTranslation } from "react-i18next"

const MapView = React.forwardRef(({ products }, ref) => {
    const { user } = useUser()
    const [positions, setPositions] = useState([])
    var _ = require('lodash/core');
    const { t } = useTranslation()
    //console.log(products)

    useEffect(() => {
        const fetchPositions = async () => {
            const posPromises = products.map(async (product) => {
                if (product.User.Address != "") {
                    var coords = await geocodeAddress(product.User.Address)
                    if (coords != null && coords.status === "OK" && coords.results.length > 0) {

                        if ('partial_match' in coords.results[0] && coords.results[0].partial_match == true)
                        {
                            coords = coords.results[0].geometry.location
                            return {
                                ...product, position: { longitude: coords.lng, latitude: coords.lat }, partial_match: true   //Google BS
                            }
                        }
                        coords = coords.results[0].navigation_points[0].location;
                        return {
                            ...product, position: coords, partial_match: false
                        }
                    }
                }
            })
            const posResults = (await Promise.all(posPromises)).filter( (item) => item !== undefined)

            

            //const filteredResults = posResults.filter((product) => {
            //    return user.role === "SuperAdmin" || (user.role === "Admin")
            //})
            if (posResults.length > 0 && !_.isEqual(positions, posResults))
                setPositions(posResults)
        }

        if(positions.length == 0)
            fetchPositions()
    }, [])

    const getImg = (color) => `${process.env.PUBLIC_URL}/images/map/placeholder_${color}.png`

    const commonIconProps = {
        iconSize: [40, 40],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
    }

    const okIcon = (Cards) => new L.Icon({
        ...commonIconProps,
        iconUrl: getImg(getStatusColor(mapStatus(getStatusAggregate(Cards))))
    })

    const partialMatchIcon = new L.Icon({
        ...commonIconProps,
        iconUrl: getImg("gray")
    })

    const offlineIcon = new L.Icon({ ...commonIconProps, iconUrl: getImg("gray") })

    return (
        <MapContainer ref={ref} center={[56.88, 14.81]} zoom={5} style={{ height: "600px", width: "100%" }}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            {positions.map((product, i) => (
                <Marker
                    key={i}
                    position={[product.position.latitude, product.position.longitude]}
                    icon={okIcon(product.Cards)}
                >
                    <Popup>
                        {product.partial_match == true && (<>
                            <strong>{t("page.mapview.warning")}</strong>
                            <br /></>
                        )}
                        <strong>{t("User")}:</strong> {product.User.FirstName + " " + product.User.LastName}
                        <br />
                        <strong>{t("Address")}:</strong> {product.User.Address}
                        <br />
                        <strong>{t("Telefon")}:</strong> {product.User.Phone}
                        <br />
                        <strong>{t("page.editaccount.email")}:</strong> {product.User.EMail}
                        <br />
                        <strong>{t("Reseller")}:</strong> {product.User.ResellerName}
                        <br />
                        <strong>{t("page.cardmanage.status")}:</strong> {mapStatus(getStatusAggregate(product.Cards)).toUpperCase()}
                        
                    </Popup>
                </Marker>
            ))}
        </MapContainer>
    )
})

export default MapView
